import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ITextNode } from '../kb3d-models';
import { Token } from '../token';
import { MeshNode } from './mesh-node';

@Kb3dModel({
    token: Token.TextNode,
})
export class TextNode extends MeshNode implements ITextNode {
    curveRadius = 0;
    charSpacing = 1;

    text = '';

    fontFile: string;
    fontSize: number;
}
